import React, { useState } from "react";
import {
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { auth } from "../../firebase";
import "./Login.css";
import {
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";

export default function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const initialMode =
    searchParams.get("mode") === "admin" ? "admin" : "client";

  const [mode, setMode] = useState(initialMode);

  // CLIENT PORTAL
  const [clientUsername, setClientUsername] = useState("");
  const [clientPassword, setClientPassword] = useState("");
  

  // ADMIN
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  /* =========================
     CLIENT LOGIN
     ========================= */
    const handleClientSubmit = async (e) => {
      e.preventDefault();

      setError("");
      setLoading(true);

      const username = clientUsername.trim().toLowerCase();

      try {
        let clientEmail = "";

        if (username === "verizon") {
          clientEmail = "verizon@portal.gofoton.com";
        } else {
          throw new Error("Invalid client");
        }

        const userCredential = await signInWithEmailAndPassword(
          auth,
          clientEmail,
          clientPassword
        );

        sessionStorage.setItem(
          "portalClient",
          JSON.stringify({
            uid: userCredential.user.uid,
            id: "verizon",
            name: "Verizon",
            authenticated: true,
          })
        );

        navigate("/portal", {
          replace: true,
        });
      } catch (err) {
        console.error("Client login failed:", err);
        setError("Invalid username or password.");
      } finally {
        setLoading(false);
      }
    };

  /* =========================
     ADMIN LOGIN
     ========================= */

  const handleAdminSubmit = async (e) => {
  e.preventDefault();

  setError("");
  setLoading(true);

  const normalizedEmail =
    email.trim().toLowerCase();

  try {
    // Block all client portal accounts
    // from even attempting Admin Access.
    if (
      normalizedEmail.endsWith(
        "@portal.gofoton.com"
      )
    ) {
      setError("Invalid email or password.");
      return;
    }

    const userCredential =
      await signInWithEmailAndPassword(
        auth,
        normalizedEmail,
        password
      );

    const signedInEmail =
      userCredential.user.email
        ?.trim()
        .toLowerCase();

    // Second safety check AFTER Firebase
    // authenticates the account.
    if (
      !signedInEmail ||
      signedInEmail.endsWith(
        "@portal.gofoton.com"
      )
    ) {
      await signOut(auth);

      setError("Invalid email or password.");
      return;
    }

    navigate("/admin", {
      replace: true,
    });
  } catch (err) {
    console.error(
      "Admin login failed:",
      err
    );

    setError("Invalid email or password.");
  } finally {
    setLoading(false);
  }
};

  const changeMode = (newMode) => {
    setMode(newMode);
    setError("");
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-shell">

        {/* LOGIN TYPE TOGGLE */}

        <div className="login-toggleCard">

          <button
            type="button"
            className={`login-toggleBtn ${
              mode === "client" ? "is-active" : ""
            }`}
            onClick={() => changeMode("client")}
          >
            Client Portal
          </button>

          <button
            type="button"
            className={`login-toggleBtn ${
              mode === "admin" ? "is-active" : ""
            }`}
            onClick={() => changeMode("admin")}
          >
            Admin Access
          </button>

        </div>

        {/* MAIN LOGIN CARD */}

        <div className="login-card">

          {mode === "client" ? (

            <div className="login-clientPanel">

              <h1 className="login-title">
                Client Portal
              </h1>

              <p className="login-subtitle">
                Access project documents, order information,
                resources, and support.
              </p>

              <form
                className="login-form"
                onSubmit={handleClientSubmit}
              >

                <div className="login-field">
                  <label>Username</label>

                  <input
                    type="text"
                    value={clientUsername}
                    onChange={(e) =>
                      setClientUsername(e.target.value)
                    }
                    required
                    autoComplete="username"
                  />
                </div>

                <div className="login-field">
                  <label>Password</label>

                  <input
                    type="password"
                    value={clientPassword}
                    onChange={(e) =>
                      setClientPassword(e.target.value)
                    }
                    required
                    autoComplete="current-password"
                  />
                </div>

                {error && (
                  <div className="login-error">
                    {error}
                  </div>
                )}

                <button
                  className="login-button"
                  type="submit"
                  disabled={loading}
                >
                  {loading
                    ? "Signing in..."
                    : "Sign in"}
                </button>

              </form>

              <div className="login-helper">
                Need access? Contact your Go!Foton
                representative.
              </div>

            </div>

          ) : (

            <div className="login-adminPanel">

              <h1 className="login-title">
                Admin Access
              </h1>

              <p className="login-subtitle">
                Access internal tools and site administration.
              </p>

              <form
                className="login-form"
                onSubmit={handleAdminSubmit}
              >

                <div className="login-field">
                  <label>Email</label>

                  <input
                    type="email"
                    value={email}
                    onChange={(e) =>
                      setEmail(e.target.value)
                    }
                    required
                    autoComplete="email"
                  />
                </div>

                <div className="login-field">
                  <label>Password</label>

                  <input
                    type="password"
                    value={password}
                    onChange={(e) =>
                      setPassword(e.target.value)
                    }
                    required
                    autoComplete="current-password"
                  />
                </div>

                {error && (
                  <div className="login-error">
                    {error}
                  </div>
                )}

                <button
                  className="login-button"
                  disabled={loading}
                >
                  {loading
                    ? "Signing in..."
                    : "Sign in"}
                </button>

              </form>

            </div>
          )}

        </div>
      </div>
    </div>
  );
}